import buildRequest from '../buildRequest';

// Endpoints
import { typesEndpoint } from '../../../common/types';

// Libs
import { axios } from '../../../lib/axios';

// Utils
import { dataResponse, handleError } from '../../../utils';

export const enviarCorreoVerificacion = async params => {
  const url = typesEndpoint.correoVerificacion;

  const request = {
    ...params,
  };

  try {
    const { status, data } = await axios.post(url, request, buildRequest());
    return dataResponse({ data: data.data, statusCode: status });
  } catch (error) {
    return handleError(error);
  }
};

export const enviarCorreoFacturacion = async params => {
  const url = typesEndpoint.correoFacturacion;

  const request = {
    nombre: params.nombre,
    cedula: params.cedula,
    correo: params.correo,
    idOportunidad: params.idOportunidad,
  };

  try {
    const { status, data } = await axios.post(url, request, buildRequest());
    return dataResponse({ data: data.data, statusCode: status });
  } catch (error) {
    return handleError(error);
  }
};
